// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function ConfirmDialog(props) {
  return JsxRuntime.jsxs(DialogV5.make, {
    title: props.title,
    isOpen: props.isOpen,
    ariaLabel: props.ariaLabel,
    onDismiss: props.onCancel,
    children: [
      props.body,
      JsxRuntime.jsx("div", {
        className: "mt-[16px]"
      }),
      JsxRuntime.jsxs(View__Jsx3.make, {
        justifyContent: "flexEnd",
        flexDirection: "row",
        children: [
          props.cancelButton,
          JsxRuntime.jsx("div", {
            className: "mr-[8px]"
          }),
          props.confirmButton
        ]
      })
    ]
  });
}

let make = ConfirmDialog;

exports.make = make;
/* DialogV5 Not a pure module */
